/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Regenerated by `npm run cms:sync` from /api/cms/public/custom-pages.
 * Only PUBLISHED rows are written — drafts are invisible on the public site.
 *
 * `cmsCustomPageBySlug` is derived from `cmsCustomPages` in the writer, so
 * the array and the lookup can never disagree.
 */

export interface CmsCustomPageIndexEntry {
  slug: string
  route: string
  title_zhHant: string
  title_zhHans: string
  title_en: string
  excerpt_zhHant: string
  excerpt_zhHans: string
  excerpt_en: string
  body_md_zhHant: string
  body_md_zhHans: string
  body_md_en: string
  seo: Record<string, unknown>
  updated_at: number
  published_at: number | null
}

export const cmsCustomPages: CmsCustomPageIndexEntry[] = []

export const cmsCustomPageBySlug: Record<string, CmsCustomPageIndexEntry> = {}
